import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["completion"]

  open() {
    this.completionTarget.click()
  }
}
